import { promoTermsPercentage } from '../const/mock/activity-mock-data';
var getPromotionPercentage = function (promotion) {
    var formattedTermLength = parseInt(promotion.termLength, 10).toString();
    return promoTermsPercentage[formattedTermLength];
};
export default getPromotionPercentage;
//# sourceMappingURL=select-pay.js.map